import React from 'react';
import SafetyChassisContents from '../../../component/Safety/Chassis/SafetyChassisContents';

const Chassis = () => {
  return <SafetyChassisContents />;
};

export default Chassis;
